import BigNumber from "bignumber.js";

export class Utils {
    /**
     * @param  {number[]} list
     * @returns number
     */
    public static sum(list: number[]): number {
        return list.reduce((acc, val) => acc.plus(val), new BigNumber(0)).toNumber();
    }

    /**
     * @param  {string} email
     * @returns boolean
     */
    public static validateEmail(email: string): boolean {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }
}
